export default "__VITE_ASSET__YQUIzbzv__"